import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import RegisterUser from '../Users/RegisterUser';
import { AppName } from '../../App';

const NoAccess = (props) => {
    const { CurrentUser, RecheckAccess } = props;
    const [loadingUser, setLoadingUser] = useState(!props.UserName);

    useEffect(() => {
        if (props.UserName
            || props.CurrentUser) {
            setLoadingUser(false);
        }
    }, [props.UserName, props.CurrentUser]);

    return (!loadingUser && (
        <Row>
            <Col lg="10" xl="8" className="text-center text-md-left">
                <div className="border-secondary pb-0 mb-2" style={{ borderBottomWidth: 2, borderBottomStyle: 'solid' }}>
                    <h3 className="d-none d-sm-inline-block d-md-none">{AppName}</h3>
                    <h2 className="d-inline-block d-sm-none d-md-inline-block">{AppName}</h2>
                </div>
                <RegisterUser {...{ user: CurrentUser, RecheckAccess }} />
            </Col>
        </Row>
    ));
};

export default NoAccess;

/*
            <fieldset>
                <legend className="text-secondary border-bottom mb-0 pb-0">User has no Access!</legend>
                <em className="text-right d-block text-muted">{props.UserName}</em>
                <p>Unfortunately, you haven't been added to this system yet.<br />If you are supposed to have access already, please email <a href="mailto:itsupport@greystar.com">itsupport@greystar.com</a>.</p>
                <div>
                    <Button onClick={props.Login}>Log In</Button>
                </div>
            </fieldset>
*/


// WEBPACK FOOTER //
// ./src/components/Shared/NoAccess.js